import BackIcon from '@/icons/back-icon';
import clsx from 'clsx';

const TopNavigation = ({
  title,
  onBack,
  actions,
  className,
}: {
  title?: string;
  onBack?: () => void;
  actions?: React.ReactNode;
  className?: string;
}) => {
  return (
    <section
      className={clsx(
        'fixed left-0 top-0 flex h-20 w-full items-center justify-between px-7 py-3 text-[2rem]',
        className,
      )}
    >
      {onBack && (
        <div className="flex flex-none items-center gap-3">
          <BackIcon onClick={onBack} style={{ width: 60, height: 60 }} />
          <h4>{title}</h4>
        </div>
      )}

      <div className="flex-none">{actions}</div>
    </section>
  );
};
export default TopNavigation;
